import type { CSSProperties } from 'react'

type Props = {
  src: string
  poster?: string
  className?: string
  style?: CSSProperties
  onError?: (error: string) => void
}

export function VideoFilePlayer({ src, poster, className, style }: Props) {
  return (
    <video
      className={className}
      style={style}
      src={src}
      poster={poster}
      autoPlay
      loop
      muted
      playsInline
    />

  )
}
